// extracted by mini-css-extract-plugin
export default {"input":"A9-z","button":"B9-z","selected":"C9-z","unavailable":"D9-z","oos":"E9-z","image":"F9-z","paperCutDisabledOverlay":"G9-z"};